export default function CsNetworkTransport() {
  return (
    <h2>Cs Network Transport</h2>
  );
}
